import styled from "styled-components";
import { Scrollable } from "../../../../../common/styles";

export const AddProgramContainer = styled.div`
  width: 60vw;
  ${'' /* max-height: 56vh; */}
  ${Scrollable}
  padding-right: 20px;
  @media (max-width: 992px) {
    width: calc(100% - 25px);
    max-height: 50vh;
  }
`;

export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const ProgressContainer = styled.div`
  width: 100%;
  max-width: 560px;
  margin: 0 auto 32px;
`;
export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
